import ModalContent, { type ConfirmEmailChangeModalProps } from './ModalContent';

const ConfirmEmailChangeModal = ({ closeModal, isOpen, options }: ConfirmEmailChangeModalProps) => {
  if (!isOpen) return null;
  return <ModalContent isOpen={isOpen} closeModal={closeModal} options={options} />;
};

export default ConfirmEmailChangeModal;
